import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from 'components/common/Link';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import LoginForm from './LoginForm';

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: 434,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: 556,
    },
  },
  form: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '25px 113px 0',
    },
  },
  footer: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '25px 113px 48px',
    },
  },
  button: {
    paddingTop: 15,
    paddingBottom: 15,
    width: '100%',
  },
  typography: {
    marginTop: 16,
  },
});

const Login = ({ form, submitting, onSubmitSuccess, actions, classes }) => (
  <Paper
    className={classes.root}
    square
    elevation={5}
  >
    <LoginForm
      className={classes.form}
      form={form}
      onSubmitSuccess={onSubmitSuccess}
    />
    <div className={classes.footer}>
      <Button
        className={classes.button}
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Log In
      </Button>
      <Typography className={classes.typography} align="center">
        Don't have an account? {' '}
        <Link underline target="_blank" href="https://dme4dme.com/schedule-a-demo/">
          Sign Up
        </Link>
      </Typography>
    </div>
  </Paper>
);

Login.propTypes = {
  form: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

Login.defaultProps = {
  form: 'login',
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(Login),
);



// WEBPACK FOOTER //
// ./src/components/account/Login/Login.js